<template>
  <Modal>
    <Modal.Title>Copyright info</Modal.Title>
    <Modal.Body>
      <CopyrightInfoBody :file="file" />
    </Modal.Body>
  </Modal>
</template>

<script setup lang="ts">
import { Modal } from '@dacr/library'
import type { File } from '@/shared/graphql/router/graphql'
import CopyrightInfoBody from './CopyrightInfoBody.vue'

defineProps<{
  file: File
}>()
</script>
